import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const OPTIONS = [
  { path: "/", label: "A · Serene", pill: "bg-butter", text: "text-navy", tid: "switcher-option-a" },
  { path: "/archive-a", label: "A · Electric v1", pill: "bg-white/25", text: "text-cream", tid: "switcher-option-a-archive" },
  { path: "/option-b", label: "B · Editorial", pill: "bg-cream", text: "text-forest", tid: "switcher-option-b" },
];

export default function Switcher() {
  const loc = useLocation();
  const nav = useNavigate();
  return (
    <div className="fixed bottom-5 inset-x-0 z-[95] flex justify-center pointer-events-none px-4">
      <div className="pointer-events-auto flex items-center gap-1 rounded-full bg-navy/85 backdrop-blur-md border border-white/15 p-1.5 shadow-2xl font-bodya">
        <span className="hidden sm:block pl-3 pr-1 text-[10px] uppercase tracking-[0.18em] text-white/50">
          Mockups
        </span>
        {OPTIONS.map((o) => {
          const active =
            loc.pathname === o.path ||
            (loc.pathname !== "/option-b" && loc.pathname !== "/archive-a" && o.path === "/");
          return (
            <button
              key={o.path}
              data-testid={o.tid}
              onClick={() => nav(o.path)}
              className={`relative rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${
                active ? o.text : "text-white/70 hover:text-white"
              }`}
            >
              {active && (
                <motion.span
                  layoutId="switch-pill"
                  className={`absolute inset-0 rounded-full ${o.pill}`}
                  transition={{ type: "spring", stiffness: 400, damping: 32 }}
                />
              )}
              <span className="relative">{o.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
